<template>
  <vx-card class="my-4">
    <vs-row class="flex-col md:flex-row"
      ><vs-col class="md:w-1/3 lg:w-1/6"
        ><div class="overflow-hidden rounded-lg assignment__img">
          <img
            class="h-full w-full object-cover"
            :src="
              assignment.feedLibraryItem.imageUrl
                ? assignment.feedLibraryItem.imageUrl
                : randomFeedImage
            "
            :alt="assignment.feedLibraryItem.title"
            @error="randomFeedImage"
          /></div></vs-col
      ><vs-col class="md:w-2/3 lg:w-5/6 md:pl-8 flex flex-col">
        <div
          class="flex items-center mt-2 lg:mt-0"
          v-if="
            assignment.users && assignment.users[0].assignedFromGtbrddUserId
          "
        >
          <div class="h-8 w-8 overflow-none mr-2" v-if="userName !== 'you'">
            <img
              class="w-full h-full object-cover rounded-full"
              :src="
                userProfilePic
                  ? constants.s3Bucket +
                    '/editor/profile-pictures/' +
                    userProfilePic
                  : `https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                      userName,
                      userName
                    )}`
              "
            />
          </div>
          <div class="font-semibold text-lg text-black">
            Assigned By {{ userName }}
            {{ getAssignedUser(assignment.users[0].assignedFromGtbrddUserId) }}
          </div>
        </div>
        <div
          class="flex items-center mt-2 lg:mt-0"
          v-else-if="assignment.feedLibraryItem.assignedBy.type === 'user'"
        >
          <div class="h-8 w-8 overflow-none mr-2" v-if="userName !== 'you'">
            <img
              class="w-full h-full object-cover rounded-full"
              :src="
                userProfilePic
                  ? constants.s3Bucket +
                    '/editor/profile-pictures/' +
                    userProfilePic
                  : `https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                      userName,
                      userName
                    )}`
              "
            />
          </div>
          <div class="font-semibold text-lg text-black">
            Assigned By {{ userName }}
            {{ getAssignedUser(assignment.feedLibraryItem.assignedBy._id) }}
          </div>
        </div>
        <div v-else></div>

        <div class="flex items-center">
          <div
            class="text-black text-2xl truncate grow mt-2 lg:mt-0 clip-text--2"
            v-if="
              assignment.feedLibraryItem && assignment.feedLibraryItem.title
            "
          >
            {{ assignment.feedLibraryItem.title }}
          </div>

          <img
            @click.once="openLink(assignment.feedLibraryItem)"
            class="ml-3 mt-2 lg:mt-0 cursor-pointer"
            src="@/assets/images/icons/arrow-right-circle.svg"
            alt="right-arrow"
          />
        </div>

        <div
          class="text-lg gray-400 my-3 clip-text"
          v-if="
            assignment.feedLibraryItem &&
            assignment.feedLibraryItem.description &&
            typeof assignment.feedLibraryItem.description === 'string'
          "
        >
          {{ assignment.feedLibraryItem.description }}
        </div>

        <div
          class="text-lg gray-400 my-3"
          v-else-if="assignment.feedLibraryItem.description.length > 0"
        >
          <div
            v-for="(data, index) in assignment.feedLibraryItem.description"
            :key="index"
            v-html="data"
          ></div>
        </div>

        <div
          class="flex items-center justify-end"
          v-if="assignment.libraryItemValidationData"
        >
          <div
            class="button__decline px-3 py-2 mr-3 flex items-center"
            @click="
              validateAssignment(
                'DECLINED',
                assignment.userData,
                assignment.feedLibraryItem
              )
            "
          >
            <img
              class="mr-2"
              src="@/assets/images/icons/org-review/cross.svg"
              alt=""
            />
            Decline
          </div>
          <div
            class="button__accept px-3 py-2 flex items-center"
            @click="
              validateAssignment(
                'ACCEPTED',
                assignment.userData,
                assignment.feedLibraryItem
              )
            "
          >
            <img
              class="mr-2"
              src="@/assets/images/icons/org-review/tick.svg"
              alt=""
            />

            Accept
          </div>
        </div>
      </vs-col></vs-row
    >
  </vx-card>
</template>

<script>
import constants from "@/constants";

export default {
  data() {
    return {
      constants,
      routeToLink: false,
      userData: {},
      userProfilePic: "",
      userName: "",
    };
  },
  props: {
    assignment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
    loggedUserData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
  },
  methods: {
    getAssignedUser(id) {
      this.$store
        .dispatch("users/getAssignedUser", id)
        .then((res) => {
          this.userProfilePic = res.profilePictureUrl
            ? res.profilePictureUrl
            : "";
          if (
            res.firstName === this.loggedUserData.firstName &&
            res.lastName === this.loggedUserData.lastName
          ) {
            this.userName = "you";
          } else {
            this.userName = `${res.firstName} ${
              res.lastName ? res.lastName : ""
            }`;
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    randomFeedImage(e) {
      let i = 15; // i = number of given random images
      return (e.target.src = require(`@/assets/images/user-dashboard/blank-feed/${[
        Math.floor(Math.random() * i),
      ]}.png`));
    },
    openLink(item) {
      let link = `https://library.getboarded.com/redirect-page?itemId=${
        item.itemId
      }&type=${item.type || item.itemType}&gbuid=${this.userData._id}&gborgid=${
        this.orgId
      }&redirectsourceid=ORG_REVIEW`;
      this.routeToLink = true;
      if (link && this.routeToLink) {
        window.open(link, "_blank");
        this.routeToLink = false;
      }
    },
    validateAssignment(status, currentUser, item) {
      event.stopPropagation();
      if (item.status === "do" || item.status === "doing") {
        this.$vs.notify({
          color: "warning",
          text: "It appears that the item has not been marked as 'done' by the user yet. Therefore, the item cannot be reviewed at this time.",
        });
      } else {
        this.routeToLink = false;
        const payload = {
          libraryItemIds: [item.itemId],
          reviewStatus: status,
          gtbrddOrganizationId: this.orgData._id,
          gtbrddUserId: currentUser._id,
          // xpValue: this.reviewAssignment.libraryItemValidationData.xpValue,
        };
        this.$store
          .dispatch("alex/reviewAssignment", payload)
          .then((res) => {
            if (res) {
              this.reviewAssignmentUsers = this.reviewAssignment.users.splice(
                this.currentSelectedUserIndex,
                1
              );
            }
          })
          .catch((err) => {
            //console.log(err);
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../reviewBase.scss";

.clip-text {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  &--2 {
    -webkit-line-clamp: 2;
  }
}
</style>
